const getCurrencyCodeAndValue = ({ currencyCode, currencyValue }) => ({
  currencyCode,
  currencyValue,
});

export { getCurrencyCodeAndValue };
